import React from "react";
import { Tag } from 'antd';
// Components


const columns = ({ addColums} = {}) =>{
  var cl = [];
  addColums.map((item, index) => {
    if(index !== 0 && item.visible === true){
    cl.push(
      {
        // key: "",
        title: () => {
          if(index === 1 )return "Đợt quan trắc số"
          if(index === 2 )return "Tên đợt quan trắc"
          if(index === 3 )return "Vị trí quan trắc"
          if(index === 4 )return "Lưu lượng (m3/ngày đêm)"
          if(index > 4) return item.title
        },
        dataIndex: item.title,
        width: "120px",
        fixed: index === 1 ? 'left' : undefined,
        align: "center",
        render: (value, row) => (
            <div>
              {String(value).split(";")[1] === "False" ?
              <Tag color="#f86c6b" style={{textAlign: "center"}}>{String(value).split(";")[0]}</Tag>
              : String(value).split(";")[0]
            }
            </div>
        ),
      },
    )}
  })
return cl.map(col => ({
  ...col,
}));
};

export default columns;
